module.exports = __webpack_public_path__ + "static/media/competenciesIcon.c4bea830.svg";